<template lang="pug">
div.w-full
  //- Display each emoji-keyed section
  div.gap-y-4(v-for="(sectionValue, sectionKey) in emojiSections" :key="sectionKey")
    h4.text-sm.font-medium.mb-2 {{ sectionKey }}
    .grid.grid-cols-2.gap-4
      div(v-for="(value, key) in sectionValue" :key="key")
        p.text-xs.text-muted-foreground.mb-1 {{ key }}
        p.text-sm.font-mono {{ formatValue(value) }}
  
  //- Raw JSON (collapsible)
  details.mt-6
    summary.cursor-pointer.text-xs.text-muted-foreground(class="hover:text-foreground") View Raw JSON
    pre.mt-2.p-3.text-xs.font-mono.whitespace-pre.border.rounded {{ jsonString }}
</template>

<script lang="ts" setup>
const props = defineProps<{
  data: any
}>()

// Extract sections with emoji keys
const emojiSections = computed(() => {
  const sections: Record<string, any> = {}
  for (const [key, value] of Object.entries(props.data)) {
    if (/[💳🌍🔒📊👤💰]/u.test(key)) {
      sections[key] = value
    }
  }
  return sections
})

const jsonString = computed(() => JSON.stringify(props.data, null, 2))

function formatValue(value: any): string {
  if (value === null || value === undefined) return '—'
  if (typeof value === 'object') return JSON.stringify(value)
  return String(value)
}
</script>
